import initializeOneSignal from '../initializers/initializeOneSignal'
import initializeIAP from '../initializers/initializeIAP'
import logError from '../../../consts/log-error'
import { Auragin } from 'auragin'
import { validateDownloadedModules } from '../../versions/validate-downloaded'
import { IDiscoveryResponse } from '../../../interfaces/MFE/IDiscoveryAPI';

export default async function initMobile ( microfrontendsResponse: IDiscoveryResponse ): Promise<void> {
  return await Promise.all([
    validateDownloadedModules( microfrontendsResponse ),
    Auragin.initialize().catch(logError),
    Auragin.wsStart({ port: 9000 }).catch(logError)
  ]).then(() => {
    // initializeIAP()
    // initializeOneSignal()
  })
}
